import { render, staticRenderFns } from "./CancellationsCard.vue?vue&type=template&id=05dbb930&scoped=true"
import script from "./CancellationsCard.vue?vue&type=script&lang=js"
export * from "./CancellationsCard.vue?vue&type=script&lang=js"
import style0 from "./CancellationsCard.vue?vue&type=style&index=0&id=05dbb930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dbb930",
  null
  
)

export default component.exports